// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"be1a64f7","977":"47c2453a"}[chunkId] + ".chunk.js";
};